<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class CardAvailabilityBadge extends Vue {
        render() {
            return null
        }
    }

    export default CardAvailabilityBadge
</script>
